export const configValue = (key) => {
  if (import.meta.env.VITE_VUE_APP_HAS_RUNTIME_CONFIG === "true") {
    return globalThis.import_meta_env[key];
  } else {
    return import.meta.env["VITE_" + key];
  }
};
